import { initFooterSection } from "@/modules/section-footer";
import ready from "@/scripts/helpers/dom/ready";
import cookiePopup from "@/modules/popup-cookie";
import { headerFunctions } from "@/modules/section-header";



const icon1 = document.querySelector(".side-banner__decoration--icon-1");
const icon2 = document.querySelector(".side-banner__decoration--icon-2");

const observer = new window.IntersectionObserver(([entry]) => {
  if (entry.isIntersecting) {
    icon1.classList.add("fade-in");
    icon2.classList.add("fade-in");
    return
  }
}, {
  root: null,
  threshold: 0.1
})


ready( () => {
  headerFunctions();
  observer.observe(icon1);
  initFooterSection();
  setTimeout(() => {
    cookiePopup();
  }, 4000);
});
